export default {
  'Filters.allSources': 'Все источники',
}
